import { render, staticRenderFns } from "./NotificationsContainer.vue?vue&type=template&id=1c0d0d14&scoped=true&"
import script from "./NotificationsContainer.vue?vue&type=script&lang=js&"
export * from "./NotificationsContainer.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsContainer.vue?vue&type=style&index=0&id=1c0d0d14&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0d0d14",
  null
  
)

export default component.exports